import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const StoresTableSkeleton = () => (
  <Styles.Container>
    {Array.from({ length: 3 }).map((_, index) => (
      <Skeleton key={index} variant="rounded" width="100%" height={40} />
    ))}
  </Styles.Container>
)

export default StoresTableSkeleton
